export default "__VITE_ASSET__30db1dc6__"